import { installEarlyErrorReporting, startMonitoring } from "./lib/monitoring";

import { isRoomPrivacyPath, protectRoomReferrer } from "./lib/room-privacy";

if (isRoomPrivacyPath(window.location.pathname)) {
  protectRoomReferrer();
} else {
  installEarlyErrorReporting();
  void startMonitoring();
}
